import {useParams} from 'react-router-dom';

export function useRouteParams(props = {}) {
    const params = useParams();

    return {
        id: props.id || params.id,
        ownerId: params.ownerId,
        ...props,
        params
    };
}
